<template>
  <cards-list :items="items" :search="$route.query.q"></cards-list>
</template>

<script>
import CardsList from "./CardsList";
import database from "../database.json";

export default {
  name: "SearchResults",
  components: { CardsList },
  data() {
    return {
      items: database.reverse()
    };
  }
};
</script>
